import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Navbar.css';
import azybytenavlogobg from '../assets/azybytenavlogobg.png';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg fixed-top custom-nav">
      <div className="container">
        {/* Logo Section */}
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src={azybytenavlogobg} alt="AzyByte" className="nav-logo-img" />
          <span className={`brand-text ms-1  ${isOpen ? 'text-white' : 'text-primary'}`}>
            Technologies
          </span>
        </a>

        {/* Animated Toggler */}
        <button
          className={`menu-toggle ${isOpen ? 'active' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          type="button" aria-label="Toggle menu"
        >
          <div className="hamburger"></div>
        </button>

        {/* Unique Mobile Overlay */}
        <div className={`nav-overlay ${isOpen ? 'open' : ''}`}>
          <div className="mobile-close-btn">
            <button
              onClick={() => setIsOpen(false)}
              aria-label="Close Menu"
            >
              ✕
            </button>
          </div>
          <ul className="nav-links-mobile">
            <li style={{ '--i': 1 }}><a href="/" onClick={() => setIsOpen(false)}>Home</a></li>
            <li style={{ '--i': 2 }}><a href="/about" onClick={() => setIsOpen(false)}>About</a></li>
            <li style={{ '--i': 3 }}><a href="/services" onClick={() => setIsOpen(false)}>Services</a></li>
            <li style={{ '--i': 4 }}><a href="/privacypolicy" onClick={() => setIsOpen(false)}>Privacy Policy</a></li>
            <li style={{ '--i': 5 }}><a href="/terms" onClick={() => setIsOpen(false)}>Terms of Service</a></li>
            <li style={{ '--i': 6 }}>
              <a href="/blog" onClick={() => setIsOpen(false)}>
                Blogs
              </a>
            </li>
            <li style={{ '--i': 7 }}>
              <a href="/contact" className="mobile-contact-btn" onClick={() => setIsOpen(false)}>
                Contact Us
              </a>
            </li>
          </ul>
        </div>

        {/* Desktop Menu (Hidden on mobile) */}
        <div className="collapse navbar-collapse d-none d-lg-block">
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item"><a className="nav-link" href="/">Home</a></li>
            <li className="nav-item"><a className="nav-link" href="/about">About</a></li>
            <li className="nav-item"><a className="nav-link" href="/services">Services</a></li>
            <li className="nav-item"><a className="nav-link" href="/blog">Blogs</a></li>
            {/* <li className="nav-item"><a className="nav-link" href="#portfolio">Portfolio</a></li> */}
            <li className="nav-item ms-lg-3">
              <a href="/contact" className="btn btn-primary rounded-pill px-4">Contact Us</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;